// Shared questionnaire options for vendor approval workflow
// Used by both questionnaire components and acknowledgement page

// Question 1: Supplier Term of Payment (same for Indian and Foreign vendors)
export const supplierTermsOfPayment = [
  { value: '100ADVAOA', label: '100% Advance' },
  { value: '30AD60PR10ASPBG', label: ' 30% adv 60% on prorate against PI and 10% after submission of PBG for 1 Year' },
  { value: '100AFDEL', label: '100% afer delivery' },
  { value: '105DAYSI', label: '105 DAYS FROM INV DATE' },
  { value: '10AD80AD10', label: '10% Adv 80% against despatch & 10% balance after installati' },
  { value: '10AD90A180DI', label: '10% Advance and 90% after 180 days from date of Invoice' },
  { value: '10AD90LC45DAYS', label: '10% Advance & 90% through LC for 45 Days after delivery' },
  { value: '10AD90LC720D', label: '10% Advance Payment against PI by TT, balance 90% through irrevocable and confirmed 720 Days usance LC' },
  { value: '10AD90TT45Days', label: '10% Advance & 90% through T/T within 45 Days after delivery' },
  { value: '10ADB360DLC', label: '10% advance balance 90% by 360 days LC' },
  { value: '10ADB60DLC', label: '10% advance balance 60 days LC' },
  { value: '10ADBBS', label: '10% Advance Balance Before Shipment' },
  { value: '10ADTLC40T', label: '10% Adv Through LC , 40% on Trial zero Through LC , Balance' },
  { value: '10DAYS', label: '10 Days' },
  { value: '12ADWG8A1YB2Y', label: '12% advance with GST, 8% after 1st  year and Balance 80% after 2nd year' },
  { value: '15AD70BD15ACW20', label: '15% Advance, 70% before delivery and 15% after commissioning' },
  { value: '15AD75TTB10AI30', label: '15% advance , 75% by TT before delivery & 10% after installation of 3 months' },
  { value: '15ADBBD', label: '15%Adv balance before dispatch' },
  { value: '15ADVB720DBL', label: '15% Advance & balance within 720 days from the BL date' },
  { value: '15DAYSI', label: '15 DAYS from Invoice' },
  { value: '180DAYSI', label: '180 Days' },
  { value: '20AD15A20T20WS20B5', label: '20 % Adv, 15% after, 20% on Trial, 20% work submission & 20% balance after installation,5% balance after Success' },
  { value: '20AD15OM55APIBAT', label: '20% Advance, 15% after 1 Month, 55% against PI, Balance 10% after trial.' },
  { value: '20AD30BS25BL', label: '20% TT Advance, 30% TT Before Shipment, 25% TT Paid within 90 Days of BL, 25% TT Paid Within 180 Days of BL' },
  { value: '20AD30R50A24', label: '20% TT ADVANCE  30% TT ON READINESS 50% TT to be PAID IN APR.2024 YEAR' },
  { value: '20AD50Trial zero30', label: '20% Advance, 50% on Trial zero, Balance before dispatch' },
  { value: '20AD70AD10', label: '20% Adv 70% against despatch & 10% balance after installati' },
  { value: '20AD70ROM10H', label: '20% Advance , 70% on the readiness of the Material , 10% Holding till Warranty of the asset' },
  { value: '20AD75LC360B5R', label: '20% advance 75% LC 360 days 5% payment retention till the warranty period of the Asset' },
  { value: '20AD80LC365', label: '20% Advance, balance 80% against LC for 365 Days' },
  { value: '20ADB80A60DLC', label: '20% Advance Balance 80% by 60 Days LC' },
  { value: '20ADB80A1080DLC', label: '20% advance balance 80% by 1080 days LC' },
  { value: '20ADBBD', label: '20% Advance, Balance before dispatch' },
  { value: '20ADTLC30T', label: '20% Adv Through LC , 30% on Trial zero Through LC , Balance' },
  { value: '20ADTTB360DUL', label: '20% Adv. T/T & Bal. 80% by 360 Days Usance L/C' },
  { value: '20ADV80SD', label: '20% Advance and 80% against shipping documents' },
  { value: '20ADVBBD', label: '20% advance & 80% before despatch ( with GST Amount )' },
  { value: '20ADVBOD', label: '20% Advance and Balance On Delivery' },
  { value: '25AD65OA120DBL10', label: '25% Advance 65% OA 120 Days from BL and 10% after Installation' },
  { value: '25ADB45PDC', label: '25% Advance Balance 45Days PDC Before Dispatch' },
  { value: '25ADB60D', label: '25% ADVANCE BALANCE AFTER 60DAYS' },
  { value: '30AD30ASDBRB', label: '30% advance with work order and 30% after steel material at site and balance as per running bill.' },
  { value: '30AD50AI20AI', label: '30% advance, 50% after inspection of machine at supplier end & 20% after installation' },
  { value: '30AD50BDB30D', label: '30% advance, 50% before dispatch and balance within 30 days of Delivery' },
  { value: '30AD60A80W', label: '30 % Adv, 60% after 80% work Done & 10% balance after Sucuss' },
  { value: '30AD60API10AI', label: '30% Advance along with PO, 60% against PI .incl. GST, balance 10% immediate after successful installation' },
  { value: '30AD60BS10BL60D', label: '30% advance, 60% before shipment and 10% to be paid 60 days from B/L date.' },
  { value: '30AD60Trial zero10', label: '30% Advance, 60% on Trial zero and 10% After delivery within' },
  { value: '30ADB10AFDWG10SI', label: '30% advance of basic value, 60% after delivery with GST, 10% after successful installation' },
  { value: '30ADB30DLC', label: '30% Advance and Balance 30 Days From BL Date' },
  { value: '30ADB706M', label: '30% advance balance 70% against 6 months LC' },
  { value: '30ADB70A1080DLC', label: '30% advance balance 70% by 1080 days LC' },
  { value: '30ADVBBD', label: '30% Advance Balance Before Dispatch' },
  { value: '35AD55BD10', label: '35% Advance , 55% before Dispatch , 10% After delivery in 30' },
  { value: '35DAYS', label: '35 Days' },
  { value: '40A20T020T120GMA', label: '40% in advanced, 20% on first T0 samples, 20% on T1 Sample and 20%+ GST after mould approval' },
  { value: '40AD20BD35AS', label: '40% Advance With Work Order, 20% Before Dispatch of Material, 35% After Material Supply at Site, 5% After 5 Month of Material Supply' },
  { value: '40AD40A80W', label: '40% Adv, 40% after 80% work Done & 20% balance after Sucuss' },
  { value: '40AD40AD20', label: '40% Adv 40% against despatch  & 20% balance after installat' },
  { value: '40AD50AD10I', label: '40% advance , 50% after delivery of material & 10% after successful installation' },
  { value: '40AD50BD5AIBAPBG', label: '40% Advance 50% before dispatch 5% after Installation Balance 5% against submission of PBG for the warranty period' },
  { value: '40AD60BD', label: '40% Advance 60% Before delivery' },
  { value: '40ADTT60A30DTT', label: '40% TT in advance, 60% TT after 30 days of BL date' },
  { value: '40ADVB15D', label: '40%Advance & balance within 15 days' },
  { value: '50AD40BD10ASC', label: '50% advance 40% before dispatch 10% after successful completion' },
  { value: '50AD40Trial zero10', label: '50% Advance, 40% on Trial zero and 10% After delivery within' },
  { value: '50AD50AD', label: '50% Advance With Order And 50% Against Delivery' },
  { value: '50AD50BD', label: '50% Advance balance 50% before dispatch' },
  { value: '50ADVB30D', label: '50% adv and balance 30 Days' },
  { value: '50ADVB45DP', label: '50% ADV And Balance PDC of 45 DAYS' },
  { value: '5AD85AD10', label: '5% Adv 85% against despatch & 10% balance after installatio' },
  { value: '5ADTLC45Trial zero', label: '5% Adv Through LC , 45% on Trial zero Through LC , Balance 5' },
  { value: '60AD30BD10AD', label: '60% Advance, 30% Before Dispatch and 10% after delivery' },
  { value: '60AD40AI', label: 'Advance Amount Payable @ 60% of Basic Amt and balance 40% after installation' },
  { value: 'c', label: '7 Days' },
  { value: '80AD20ACW', label: '80% Advance, 20% After Complition of Work' },
  { value: 'ADV20501515', label: 'Adv ,20% + 50%+ 15% + complete the work 15%' },
  { value: 'AGSTDEL', label: 'Against Delivery' },
  { value: 'APA', label: 'As Per Annexure' },
  { value: 'IMMEDIATE', label: 'Immediate' },
  { value: 'LC120DAYBL', label: 'LC 120 Days from date of BL' },
  { value: 'LC150DAYBL', label: 'LC 150 Days from date of BL' },
  { value: 'LC180DAYBL', label: 'LC 180 Days from date of BL' },
  { value: 'LC180DAYI', label: 'LC 180 Days from date of Invoice' },
  { value: 'LC30DAYSBL', label: '30 Days LC' },
  { value: 'LC360DAYS', label: 'LC 360 Days' },
  { value: 'LC45DAYSBL', label: '45 Days LC From Bill of Lading' },
  { value: 'LC45DAYSI', label: 'LC 45 Days from date of Invoice' },
  { value: 'LC60DAYSBL', label: 'LC 60 Days from date of BL' },
  { value: 'LC60DAYSI', label: 'LC 60 Days from date of Invoice' },
  { value: 'LC75DAYSI', label: 'LC 75 Days from date of Invoice' },
  { value: 'LC90DAYSBL', label: 'LC 90 Days from date of BL' },
  { value: 'LC90DAYSI', label: 'LC 90 Days from date of Invoice' },
  { value: 'LCATSIGHT', label: 'LC AT SITE' },
  { value: 'OA120DASBL', label: 'OA-120 Days from date of BL' },
  { value: 'OA120DAYSI', label: 'OA-120 Days from date of Invoice' },
  { value: 'OA150DASBL', label: 'OA-150 Days from date of BL' },
  { value: 'OA180DAYBL', label: 'OA-180 Days from date of BL' },
  { value: 'OA20ADVAN', label: '20% Advance, Balance under satisfactory completeion of work' },
  { value: 'OA30ADVAN', label: '30% Advance, Balance under satisfactory completeion of work' },
  { value: 'OA30DAYSBL', label: '30 Days from date of BL' },
  { value: 'OA30DAYSI', label: 'OA 30 Days from date of Invoice' },
  { value: 'OA45DAYSBL', label: 'OA- 45 Days from date of BL' },
  { value: 'OA45DAYSI', label: 'OA- 45 Days from date of Invocie' },
  { value: 'OA50ADVAN', label: '50% Advance, Balance under satisfactory completeion of work' },
  { value: 'OA60DAYSBL', label: 'OA-60 Days from date of BL' },
  { value: 'OA60DAYSI', label: 'OA-60 Days from date of Invoice' },
  { value: 'OA75ADVAN', label: '75% Advance, Balance under satisfactory completeion of work' },
  { value: 'OA75DAYSBL', label: 'OA-75 Days from date of BL' },
  { value: 'OA75DAYSI', label: 'OA-75 Days from date of Invoice' },
  { value: 'OA7DAYSI', label: 'OA 7 Days from date of Invoice' },
  { value: 'OA90DAYSBL', label: 'OA- 90 Days from date of BL' },
  { value: 'OA90DAYSI', label: 'OA- 90 Days from date of Invoice' },
  { value: 'PDC25DAYS', label: 'PDC 25 DAYS' },
  { value: 'PDC30DAYS', label: 'PDC 30 Days' },
  { value: 'PDC45DAYS', label: 'PDC 45 Days' },
  { value: 'PDC60DAYS', label: 'PDC 60 Days' },
  { value: 'PDC75DAYS', label: 'PDC 75 Days' },
  { value: 'TT105DBL', label: 'TT 105 days from Date of Bill of Lading' },
  { value: 'TTAdvance', label: 'TT Advance' },
  { value: 'TTAGTBL', label: '100% TT Against BL Copy' }
];

// Question 2: Supplier Payment Method (same for Indian and Foreign vendors)
export const supplierPaymentMethods = [
  { value: 'BY CHEQUE', label: 'BY CHEQUE' },
  { value: 'LC', label: 'LC' },
  { value: 'NEFT/RTGS', label: 'NEFT/RTGS' },
  { value: 'PDC', label: 'PDC' },
  { value: 'TT', label: 'TT' }
];

// Question 3: Supplier Delivery Terms (same for Indian and Foreign vendors)
export const supplierDeliveryTerms = [
  { value: 'AS PER SCH', label: 'AS PER SCH' },
  { value: 'CIF', label: 'CIF' },
  { value: 'EXTRA', label: 'EXTRA' },
  { value: 'EXW', label: 'EXW' },
  { value: 'EXWDDN', label: 'EXWDDN' },
  { value: 'FOB', label: 'FOB' },
  { value: 'FOR', label: 'FOR' },
  { value: 'IN', label: 'IN' },
  { value: 'LCL', label: 'LCL' },
  { value: 'TO PAID', label: 'TO PAID' },
  { value: 'TO PAY', label: 'TO PAY' }
];

// Question 4: Supplier Mode of Delivery (same for Indian and Foreign vendors)
export const supplierModeOfDelivery = [
  { value: 'BY AIR', label: 'BY AIR' },
  { value: 'BY COURIER', label: 'BY COURIER' },
  { value: 'BY HAND', label: 'BY HAND' },
  { value: 'BY ROAD', label: 'BY ROAD' },
  { value: 'BY SEA', label: 'BY SEA' }
];

// Question 5: Supplier Group - Indian vendors
export const indianSupplierGroups = [
  { value: 'CR-AGT', label: 'CR-AGT | Creditors Agents' },
  { value: 'CR-BANK', label: 'CR-BANK | Creditors Bank' },
  { value: 'CR-CAP', label: 'CR-CAP | Creditors Capex' },
  { value: 'CR-CO', label: 'CR-CO | Creditors Consumable' },
  { value: 'CR-EX', label: 'CR-EX | Creditors Expense' },
  { value: 'CR-INT', label: 'CR-INT | Creditors Inter Unit' },
  { value: 'CR-JW', label: 'CR-JW | Creditors Job work' },
  { value: 'CR-KMP', label: 'CR-KMP | Creditors Key Management Persons' },
  { value: 'CR-PK', label: 'CR-PK | Creditors Packing Material' },
  { value: 'CR-RM', label: 'CR-RM | Creditors Raw Material' },
  { value: 'CR-RPT', label: 'CR-RPT | Creditors Related Parties' },
  { value: 'CR-SC', label: 'CR-SC | Creditors Sister Concern' },
  { value: 'CR-STAT', label: 'CR-STAT | Creditors Statutory' },
  { value: 'CR-TPT', label: 'CR-TPT | Creditors Transporter' }
];

// Question 5: Supplier Group - Foreign vendors
export const foreignSupplierGroups = [
  { value: 'CR-IMP', label: 'CR-IMP | Creditors Imports Raw Material' },
  { value: 'CR-IMP-CAP', label: 'CR-IMP-CAP | Creditors Import Capex' },
  { value: 'CR-IMP-EXP', label: 'CR-IMP-EXP | Creditors Import Expense' },
  { value: 'CR-IMP-SER', label: 'CR-IMP-SER | Creditors Import Service' }
];

// Question 6: Supplier Categories (same for Indian and Foreign vendors)
export const supplierCategories = [
  { value: 'rw', label: 'RW-Raw Material' },
  { value: 'pk', label: 'PK-Packaging' },
  { value: 'consumables', label: 'Consumables' },
  { value: 'others', label: 'Others' }
];

// Question 7: Commodity Code (same for Indian and Foreign vendors)
export const commodityCodes = [
  { value: 'AA', label: 'AA - Aluminium' },
  { value: 'AB', label: 'AB - FG-Extruded Sheet' },
  { value: 'AC', label: 'AC - FG-HE Coil' },
  { value: 'AD', label: 'AD - FG-IDU' },
  { value: 'AE', label: 'AE - FG-Inner Case' },
  { value: 'AF', label: 'AF - FG-MFC' },
  { value: 'AG', label: 'AG - FG-ODU' },
  { value: 'AH', label: 'AH - FG-PLC' },
  { value: 'AI', label: 'AI - FG-SMC' },
  { value: 'AJ', label: 'AJ - Steel' },
  { value: 'AK', label: 'AK - FG-WAC' },
  { value: 'AL', label: 'AL - FG-ODU Kit' },
  { value: 'AM', label: 'AM - FG-SAC' },
  { value: 'AN', label: 'AN - ODU-Accessories' },
  { value: 'AO', label: 'AO - Compressor' },
  { value: 'AP', label: 'AP - Motor' },
  { value: 'AQ', label: 'AQ - RM-IDU' },
  { value: 'AR', label: 'AR - RM-HE Coil' },
  { value: 'AS', label: 'AS - Sticker & Label' },
  { value: 'AT', label: 'AT - Remote' },
  { value: 'AU', label: 'AU - Foam' },
  { value: 'AV', label: 'AV - EPS' },
  { value: 'AX', label: 'AX - Brass Parts' },
  { value: 'AY', label: 'AY - Capacitor' },
  { value: 'AZ', label: 'AZ - Cross Flow Fan' },
  { value: 'BA', label: 'BA - FG-Portable AC' },
  { value: 'BB', label: 'BB - Fan' },
  { value: 'BC', label: 'BC - Gas' },
  { value: 'BD', label: 'BD - Hardware' },
  { value: 'BE', label: 'BE - Ink' },
  { value: 'BF', label: 'BF - Poly Bag' },
  { value: 'BG', label: 'BG - Rear Grill' },
  { value: 'BH', label: 'BH - Hardware Other' },
  { value: 'BI', label: 'BI - Rubber Parts' },
  { value: 'BJ', label: 'BJ - Service Valve' },
  { value: 'BK', label: 'BK - Tape' },
  { value: 'BL', label: 'BL - Wire' },
  { value: 'BM', label: 'BM - FG-PP Roll' },
  { value: 'BN', label: 'BN - Bolt' },
  { value: 'BO', label: 'BO - Brazing Rod' },
  { value: 'BP', label: 'BP - Carton Box' },
  { value: 'BQ', label: 'BQ - Chemical' },
  { value: 'BR', label: 'BR - FG-Copper Tubing' },
  { value: 'BS', label: 'BS - Powder' },
  { value: 'BT', label: 'BT - Terminal Block' },
  { value: 'BU', label: 'BU - Packing Material' },
  { value: 'BV', label: 'BV - Copper Tube' },
  { value: 'BW', label: 'BW - Plastic Granules' },
  { value: 'BX', label: 'BX - General' },
  { value: 'BY', label: 'BY - Printing & Stationery' },
  { value: 'BZ', label: 'BZ - Electrical & Electronics Store & Spares' },
  { value: 'CA', label: 'CA - Mechanical' },
  { value: 'CB', label: 'CB - Plastic Grinding' },
  { value: 'CM', label: 'CM - Oil & Lubricants' },
  { value: 'CO', label: 'CO - Tools & Die' },
  { value: 'CP', label: 'CP - SKD Assembly' },
  { value: 'CT', label: 'CT - EPS Assembly' },
  { value: 'CU', label: 'CU - FG-WAC Kit' },
  { value: 'CV', label: 'CV - Controller' },
  { value: 'CW', label: 'CW - Display PCB' },
  { value: 'CX', label: 'CX - Blower' },
  { value: 'CZ', label: 'CZ - Lab Equipments' },
  { value: 'DA', label: 'DA - FG-IDU Dummy' },
  { value: 'DB', label: 'DB - Brazing Ring-Imp' },
  { value: 'DC', label: 'DC - SCRAP' },
  { value: 'DG', label: 'DG - RM-Aluminium' },
  { value: 'DH', label: 'DH - RM-ODU' },
  { value: 'DI', label: 'DI - RM-WAC' },
  { value: 'DJ', label: 'DJ - FG-Aluminium Components' },
  { value: 'DK', label: 'DK - RM-MFC' },
  { value: 'DN', label: 'DN - FG-ODU Dummy' },
  { value: 'DO', label: 'DO - FG-SAC Dummy' },
  { value: 'DP', label: 'DP - Capillary Tube' },
  { value: 'DR', label: 'DR - Louver/Stepping Motor' },
  { value: 'DS', label: 'DS - FG-IDU Kit' },
  { value: 'DT', label: 'DT - Main PCB' },
  { value: 'DU', label: 'DU - FG-CAC' },
  { value: 'DV', label: 'DV - Master Batch' },
  { value: 'DW', label: 'DW - Glass' },
  { value: 'DX', label: 'DX - PCB' },
  { value: 'DY', label: 'DY - Gas AC' },
  { value: 'DZ', label: 'DZ - Compressor-Cust' },
  { value: 'EA', label: 'EA - Compressor-Imp' },
  { value: 'EB', label: 'EB - Controller IDU-Cust' },
  { value: 'EC', label: 'EC - Controller ODU-Cust' },
  { value: 'ED', label: 'ED - Controller WAC-Cust' },
  { value: 'EF', label: 'EF - Controller IDU' },
  { value: 'EG', label: 'EG - Controller IDU-Imp' },
  { value: 'EH', label: 'EH - Controller ODU-Imp' },
  { value: 'EI', label: 'EI - Controller WAC-Imp' },
  { value: 'EJ', label: 'EJ - Controller WAC' },
  { value: 'EK', label: 'EK - Copper Part RM-Cust' },
  { value: 'EL', label: 'EL - FG-Electrical And Electronics Parts' },
  { value: 'EM', label: 'EM - Copper Tube-Imp' },
  { value: 'EN', label: 'EN - Copper Capillary Tube RM' },
  { value: 'EO', label: 'EO - Copper Capillary Tube BOP' },
  { value: 'EQ', label: 'EQ - Display PCB IDU-Cust' },
  { value: 'ER', label: 'ER - Electrical And Electronics Parts RM' },
  { value: 'ES', label: 'ES - Display PCB IDU' },
  { value: 'ET', label: 'ET - Display PCB IDU-Imp' },
  { value: 'EU', label: 'EU - Display PCB WAC-Imp' },
  { value: 'EV', label: 'EV - Display PCB WAC' },
  { value: 'EW', label: 'EW - Electrical And Electronics Parts RM-Cust' },
  { value: 'EX', label: 'EX - Electrical And Electronics Parts RM-Imp' },
  { value: 'EY', label: 'EY - Remote-Cust' },
  { value: 'EZ', label: 'EZ - Remote-Imp' },
  { value: 'FA', label: 'FA - Sleeve' },
  { value: 'FB', label: 'FB - Insulation Tube' },
  { value: 'FC', label: 'FC - Jacket' },
  { value: 'FE', label: 'FE - Rubber Part RM' },
  { value: 'FF', label: 'FF - Aluminium Parts RM' },
  { value: 'FG', label: 'FG - Copper Part RM' },
  { value: 'FI', label: 'FI - Plastic Part RM' },
  { value: 'FJ', label: 'FJ - Sheet Metal Part RM' },
  { value: 'FK', label: 'FK - Motor-Cust' },
  { value: 'FL', label: 'FL - Filter' },
  { value: 'FM', label: 'FM - Wire-Cust' },
  { value: 'FP', label: 'FP - Aluminium Brazing Filler-Imp' },
  { value: 'FQ', label: 'FQ - Aluminium Strip-Imp' },
  { value: 'FQ2', label: 'FQ2 - Aluminium Pipe-Imp' },
  { value: 'FR', label: 'FR - Aluminium Foil-Imp' },
  { value: 'FS', label: 'FS - Brass Part-Imp' },
  { value: 'FT', label: 'FT - Brazing Rod-Imp' },
  { value: 'FU', label: 'FU - Cross Flow Fan-Imp' },
  { value: 'FV', label: 'FV - Moulding RM' },
  { value: 'FW', label: 'FW - Louver/Stepping Motor-Imp' },
  { value: 'FX', label: 'FX - Motor-Imp' },
  { value: 'FY', label: 'FY - Plastic Part RM-Imp' },
  { value: 'FZ', label: 'FZ - Service Valve-Imp' },
  { value: 'GA', label: 'GA - Battery' },
  { value: 'GB', label: 'GB - Putty' },
  { value: 'GD', label: 'GD - Edge Angle' },
  { value: 'GE', label: 'GE - Corrugated Separator' },
  { value: 'GF', label: 'GF - P.P Band' },
  { value: 'GG', label: 'GG - Staple Pin' },
  { value: 'GH', label: 'GH - Wiring Diagram Sticker' },
  { value: 'GI', label: 'GI - Strip Sticker' },
  { value: 'GJ', label: 'GJ - SOWM Label' },
  { value: 'GK', label: 'GK - Ribbon' },
  { value: 'GL', label: 'GL - Rating Label Sticker' },
  { value: 'GM', label: 'GM - Manual' },
  { value: 'GN', label: 'GN - Logo Sticker' },
  { value: 'GO', label: 'GO - Escutcheon Sticker' },
  { value: 'GP', label: 'GP - BEE Label Sticker' },
  { value: 'GR', label: 'GR - IDU Front Grill' },
  { value: 'GS', label: 'GS - ODU Fan Guard' },
  { value: 'GT', label: 'GT - IDU Drain Hose' },
  { value: 'GU', label: 'GU - WAC Front Grill' },
  { value: 'GV', label: 'GV - Master Batch-Cust' },
  { value: 'GW', label: 'GW - Plastic Granules-Cust' },
  { value: 'GY', label: 'GY - Aluminium Foil-Local' },
  { value: 'HA', label: 'HA - Copper Tube Plain Domestic' },
  { value: 'HB', label: 'HB - Copper Tube IGT Domestic' },
  { value: 'HC', label: 'HC - Copper Tube Plain-Imp' },
  { value: 'HD', label: 'HD - Copper Tube IGT-Imp' },
  { value: 'HE', label: 'HE - Copper Capillary Tube' },
  { value: 'HF', label: 'HF - Tool & Die Parts' },
  { value: 'HG', label: 'HG - Robotic System' },
  { value: 'HI', label: 'HI - Iljin Parts' },
  { value: 'HJ', label: 'HJ - QMD IDU Kit' },
  { value: 'HK', label: 'HK - QMD ODU Kit' },
  { value: 'NA', label: 'NA - NA for Other vendors' },
  { value: 'HL', label: 'HL - Fixed Asset' },
  { value: 'SM', label: 'SM - Service' },
  { value: 'HM', label: 'HM - Job Work' }
];

/** Single lookup for commodity labels (keeps dropdown + displays in sync). */
const commodityCodeLabelByValue = Object.fromEntries(commodityCodes.map((opt) => [opt.value, opt.label]));

/** Display label for a stored commodity code (questionnaire, company profile, etc.). */
export function formatCommodityCode(value) {
  if (!value) return 'Not specified';
  return commodityCodeLabelByValue[value] ?? value;
}

// Helper function to get the short code from a stored value for any field.
// Stored values may be the code itself (e.g. "100ADVAOA") or the full
// description (e.g. "100% Advance") depending on how the vendor was imported.
// Returns the code when the value matches a known code or description,
// otherwise returns the value unchanged.
export const getQuestionnaireCode = (fieldKey, value) => {
  if (!value) return value;

  const optionSets = {
    supplier_term_of_payment: supplierTermsOfPayment,
    supplier_payment_method: supplierPaymentMethods,
    supplier_delivery_terms: supplierDeliveryTerms,
    supplier_mode_of_delivery: supplierModeOfDelivery,
  };

  const options = optionSets[fieldKey];
  if (!options) return value;

  // Already a valid code → keep it.
  if (options.some((opt) => opt.value === value)) return value;

  // Match on description (case-insensitive, trimmed) → return its code.
  const normalized = String(value).trim().toLowerCase();
  const byLabel = options.find((opt) => opt.label.trim().toLowerCase() === normalized);
  return byLabel ? byLabel.value : value;
};

// Helper function to get label from value for any field
export const getQuestionnaireLabel = (fieldKey, value, countryOrigin = 'IN') => {
  if (!value) return 'Not specified';
  
  // Combine Indian and Foreign supplier groups for lookup
  const allSupplierGroups = [...indianSupplierGroups, ...foreignSupplierGroups];
  
  // Create lookup maps
  const maps = {
    supplier_term_of_payment: Object.fromEntries(supplierTermsOfPayment.map(opt => [opt.value, opt.label])),
    supplier_payment_method: Object.fromEntries(supplierPaymentMethods.map(opt => [opt.value, opt.label])),
    supplier_delivery_terms: Object.fromEntries(supplierDeliveryTerms.map(opt => [opt.value, opt.label])),
    supplier_mode_of_delivery: Object.fromEntries(supplierModeOfDelivery.map(opt => [opt.value, opt.label])),
    supplier_group: Object.fromEntries(allSupplierGroups.map(opt => [opt.value, opt.label])),
    supplier_category: Object.fromEntries(supplierCategories.map(opt => [opt.value, opt.label])),
    commodity_code: commodityCodeLabelByValue,
  };
  
  return maps[fieldKey]?.[value] || value;
};
